import { ReactElement } from "react";

import { Form } from "react-bulma-components";

import { getTransportationType } from "enums/transportationType";
import { SuggestedPreparedRouteDetail } from "models/suggestedPreparedRoute";

const { Field, Control, Checkbox } = Form;

const PUBLIC_TRANSPORTATION_TYPE = ["train", "bus"];

export interface CommuterPassCheckBoxProps {
  suggestedPreparedRouteIndex: number;
  suggestedPreparedRouteDetail: SuggestedPreparedRouteDetail;
  preparedRouteDetailIndex: number;
  changeUseCommuterPass: (
    suggestedPreparedRouteIndex: number,
    preparedRouteDetailIndex: number,
    useCommuterPass: boolean
  ) => void;
}

export function CommuterPassCheckBox({
  suggestedPreparedRouteIndex,
  suggestedPreparedRouteDetail,
  preparedRouteDetailIndex,
  changeUseCommuterPass,
}: CommuterPassCheckBoxProps): ReactElement | null {
  const isPublicTransportationType = (transportationType: number): boolean =>
    PUBLIC_TRANSPORTATION_TYPE.includes(
      getTransportationType(transportationType) || ""
    );

  return isPublicTransportationType(
    suggestedPreparedRouteDetail.transportationType || 0
  ) ? (
    <Field>
      <Control>
        <Checkbox
          checked={suggestedPreparedRouteDetail.useCommuterPass}
          onChange={(event) => {
            changeUseCommuterPass(
              suggestedPreparedRouteIndex,
              preparedRouteDetailIndex,
              event.target.checked
            );
          }}
        />
      </Control>
    </Field>
  ) : null;
}
